import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { CheckaService } from './checka.service';

angular.module('workshop.checka', [])
  .service('checkaApi', downgradeInjectable(CheckaService));